import { GetterTree } from "vuex";
import { AppState } from "./index";
import { RootState } from "../index";

export const getters: GetterTree<AppState, RootState> = {
  isNavExpanded(state): boolean {
    return state.isNavExpanded;
  },
  getLanguage(state): string | undefined {
    return state.language;
  },
};
